import { Direction } from '~shared/utils/sort';
import {
  safeGetSessionStorageItem,
  safeRemoveSessionStorageItem,
  safeSetSessionStorageItem,
} from '~shared/utils/storage/sessionStorage';

export interface SortingRule {
  column: string;
  direction: Direction;
}

export function readPersistedSortingRule(
  storageKey: string,
  validColumns: string[]
) {
  const rawSort = safeGetSessionStorageItem(storageKey);

  if (!rawSort) {
    return null;
  }

  try {
    const parsedSort = JSON.parse(rawSort);

    if (
      !parsedSort ||
      typeof parsedSort.column !== 'string' ||
      !validColumns.includes(parsedSort.column) ||
      !Object.values(Direction).includes(parsedSort.direction)
    ) {
      return null;
    }

    return parsedSort as SortingRule;
  } catch {
    return null;
  }
}

export function persistSortingRule(
  storageKey: string,
  sortRule: SortingRule | null | undefined
) {
  if (!sortRule) {
    safeRemoveSessionStorageItem(storageKey);
    return;
  }

  safeSetSessionStorageItem(storageKey, JSON.stringify(sortRule));
}
